import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
  // { value: 'weight', label: 'Total Weight (kg)'},
  // { value: 'teu', label: 'Total TEU'},
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];

export const defaultData = {
  name: "Argentina Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  isUIGridNew: true,
  isUEGridNew: true,
  minimumDateAllowed: "2014-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("argentinaImportLatestArrivalDate"),
    getSearchResult: getApiUrl("argentinaImportSearch"),
    getAnalyticsData: getApiUrl("analytics/argentinaImportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_argentina_imports_2"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_argentina_imports_2"),
    getShipmentByID: getApiUrl("argentinaImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfArgentinaImport2"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/argentinaImportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.ar_import.country_small,
  countryCaps: globalCountryDetails.ar_import.country_caps,
  product_id: globalCountryDetails.ar_import.product_id,
  compare_product_id: globalCountryDetails.ar_import.compareProduct,
  country_CamelCase: globalCountryDetails.ar_import.product_id,
  countryCode: globalCountryDetails.ar_import.countryCode,
  countryType: globalCountryDetails.ar_import.countryType,
  manyCountryType: globalCountryDetails.ar_import.manyCountryType,
  countryTypeCode: globalCountryDetails.ar_import.countryTypeCode,
  redirectionID: globalCountryDetails.ar_import.redirectionID,
  analyticsCountryID: globalCountryDetails.ar_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Import",
  isHandleTrademoAccount: false,
  picker: {
    monthPicker: true,
    datePicker: false,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: false,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: false,
    product_hscode: true,
    exporters: false,
    importers: true,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.ar_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    // shipper: 'derivedConsigneeMasterName',
    // shipper: 'exporters',
    // weight: 'weight',
    // teu: 'teu',
    portOfUnlading: "standardUnladingPortName",
    value: "shipmentValue",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
  },
  filterObj: {
    countryOfOriginRegion: "countryOfOriginRegion",
    countryOfExportRegion: "countryOfExportRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    consignee: "consignee",
    standardUnladingPortName: "standardUnladingPortName",
    modeOfTransport: "modeOfTransport",
    hsCode: "hsCode",
    shipmentValue: "shipmentValue",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    // include_master_bill: 'include_master_bill',
    // exclude_blank_consignee: 'exclude_blank_consignee',
    // exclude_blank_shipper: 'exclude_blank_shipper',
  },
  boxRangeFilterList: {
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfOriginRegion: "countryOfOrigin",
    countryOfExportRegion: "countryOfExport",
    countryOfDestinationRegion: "countryOfDestination",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfOriginRegion: [],
    countryOfExportRegion: [],
    countryOfDestinationRegion: [],
    consignee: [],
    standardUnladingPortName: [],
    modeOfTransport: [],
    hsCode: [],
    shipmentValue: [],
    sections: [],
    derivedConsigneeMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    consigneeJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    // include_master_bill: true,
    // exclude_blank_consignee: false,
    // exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfOriginRegion: false,
    countryOfExportRegion: false,
    countryOfDestinationRegion: false,
    consignee: false,
    standardUnladingPortName: false,
    modeOfTransport: false,
    hsCode: false,
    shipmentValue: false,
    sections: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    consigneeJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "9", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "consignee", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country Of Origin", categoryName: categoryType.shipperDetails, eventKey: "2", key: "countryOfOriginRegion", altKey: "countryOfOrigin", type: filterType.localizeFilter, label: "Country Of Origin", viewAllPlaceHolder: "Search in Country Of Origin Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "3", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "3", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Office", categoryName: categoryType.ports, eventKey: "4", key: "standardUnladingPortName", type: filterType.normalFilter, label: "Customs Office", viewAllPlaceHolder: "Search in Customs Office Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: categoryType.freightType, eventKey: "5", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "6", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "6", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "7", key: "shipmentValue", type: filterType.boxFilter, label: "Value (USD)", viewAllPlaceHolder: "Search in Value (USD) Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterValue" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
  ],
  highLightedColumnList: [
    { key: "destination_registeration_number", label: "Destination Registration Number" },
    { key: "destination_registration_number", label: "Destination Registration Number" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "importer_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_customs_office", label: "Custom Office" },
  ],
  shipmentSorting: [
    { columnKey: "officialization_month", value: "date", isDefault: true },
    { columnKey: "unitary_fob_cif_value_usd", value: "shipment_value" },
  ],
  exporterSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date" },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  importerSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date" },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  sortKeyMap: {
    date: "officialization_month",
    shipment_value: "unitary_fob_cif_value_usd",
    // teu: 'derived_shipment_teu'
  },
  sortKeyUniqueImpExpMap: {
    // teu: 'teu',
    date: "doc_count",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    // { label: 'Total TEUs', key: 'total_teu', valuePrefix: '', valueSuffix: '', },
    // { label: 'Total Shipments Weight', key: 'total_weight', valueSuffix: 'Kg', valuePrefix: '', },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_origin_english", filterKey: "countryOfOriginRegion", label: "Countries of Origin", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_export_english" },
    { key: "derived_country_of_export_english", filterKey: "countryOfExportRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin_english" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "derived_mode_of_transport_english", filterKey: "modeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin_english" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "officialization_month", name: "Month of Import", selector: "officialization_month", dataTip: "", type: "", dateFormat: "MMM, YYYY", sortable: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", miWidth: "100px", maWidth: "100px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "importer_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I" },
    { key: "derived_country_of_origin_english", name: "Country of Origin", selector: "derived_country_of_origin_english", dataTip: "", type: "" },
    { key: "derived_country_of_origin_english", name: "Quantity", selector: "quantity", dataTip: "", type: "", isCommaFormat: true, secondarySelector: "derived_unit_of_measurement_english" },
    { key: "unitary_fob_cif_value_usd", name: "Value (USD)", selector: "unitary_fob_cif_value_usd", dataTip: "", type: "", isCommaFormat: true, sortable: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", isCommaFormat: true },
    { key: "shipment_value", name: "Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Month of Import", value: "officialization_month", dateFormat: false, monthFormat: true },
        { label: "Destination Registration Number", value: "destination_registration_number", capitalize: true },
        { label: "Destination Item Number", value: "destination_item_number" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english", tooltip: true, tooltipField: "mode_of_transport_code", tooltipPrefix: "Mode of Transportation Code: " },
        { label: "Value (USD)", value: "unitary_fob_cif_value_usd", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "HS Code", value: "derived_hs_code" },
        // { label: 'HS Code', value: 'hs_code', isConditionalField: true,
        //     conditionalComponentData:[{
        //         dependentField: 'hs_codes_derived_string',
        //         mappingField: 'hs_code_description_map',
        //         infoText: 'Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.',
        //         isHSCodeFormatter: true,
        //         label: 'HS Code',
        //         isReadMore: true,
        //         readMoreLength: 65,
        //         isThunderIcon: false
        //     },
        //     {
        //         dependentField: 'derived_estimated_hs_code_is_present',
        //         mappingField: 'hs_codes_estimated_description_map',
        //         infoText: 'These HS Code(s) have been estimated based on the shipment data.',
        //         isHSCodeFormatter: true,
        //         label: 'Estimated HS Code',
        //         isReadMore: true,
        //         readMoreLength: 65,
        //         hideField: true,
        //     },
        //     {
        //         dependentField: '',
        //         mappingField: '',
        //         infoText: 'Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.',
        //         isHSCodeFormatter: false,
        //         label: 'HS Code',
        //         isReadMore: false,
        //         readMoreLength: 0,
        //         isThunderIcon: false
        //     }
        // ]},
        // { label: 'Product Keywords', value:'derived_unique_product_keywords', isReadMore:true, readMoreLength:160, capitalize:true, infoText:'Product keywords derived from detailed product description on each shipment.', isProductKeywordFormater: true},
        // { label: 'Estimated Shipment Value', value:'derived_shipment_value', isThunderIcon:true, valuePrefix:"USD ", isCommaFormat:true, fixedValueUpto:2,  infoText:'Shipment Value', hideField: true, },
        // { label: 'TEU', value: 'derived_shipment_teu', isThunderIcon: true, infoText:"Twenty-feet Equivalent Unit", hideField: true,},
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Origin", value: "derived_country_of_origin_english", countryFlag: true, countryCodeField: "derived_country_of_origin_english_code" },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
        { label: "Consignee Name", value: "importer_name" },
        { label: "Customs Office", value: "derived_customs_office", tooltip: true, tooltipField: "customs_office", tooltipPrefix: "Customs Office code: ", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_unit_of_measurement_english" },
        { label: "Total FOB/CIF Value", value: "total_fob_cif_value_usd", valueSuffix: " USD", isCommaFormat: true, fixedValueUpto: 2 },
        { label: "Unitary FOB/CIF Value", value: "unitary_fob_cif_value_usd", valueSuffix: " USD", isCommaFormat: true, fixedValueUpto: 2 },
        { label: "Declared Tariff Position", value: "declared_tariff_position", isCapitalise: true },
        { label: "Taxed Tariff (USD)", value: "tax_tariff_object_list", isTableFiled: true, colOne: "code", colTwo: "tax" },
      ],
    },
    // {
    //     id: 5,
    //     title: "Cargo Details",
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
    //     data: [
    //         { label: 'HS Code', value: 'hs_code' },
    // { label: 'Quantity', value: 'manifest_quantity', dynamicUnit: true, unitField: 'manifest_unit' },
    // { label: 'Total Weight', infoText: 'Gross weight of shipment', value: 'derived_weight', valueSuffix: ' Kg' },
    // { label: 'Container Load', value: 'derived_container_load', tooltip: true, tooltipField: 'derived_container_load_str', isCapitalise: true, },
    // ]
    // },
    // {
    //     id: 6,
    //     title: "Container Details",
    //     growValue: 12,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     isContainer: true,
    //     mainKey: 'container_details',
    //     uniqueKey: 'id',
    //     data: [
    //         {
    //             title: "Container Identifiers",
    //             titleKey: '',
    //             isNested: false,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Container Number', value: 'container_number', defaultValue: 'NA' },
    //                 { label: 'Seal Number', value: 'seal_number', defaultValue: 'NA' },
    //                 { label: 'Type of Service', value: 'type_of_service', defaultValue: 'NA' },
    //                 { label: 'Load Status', value: 'load_status', defaultValue: 'NA' },
    //                 { label: 'Marks & Numbers', value: 'marks_and_numbers', defaultValue: 'NA' },
    //                 { label: 'Equipment Desc.', value: 'equipment_description', defaultValue: 'NA' },
    //             ]
    //         },
    //         {
    //             title: "Container Dimension",
    //             titleKey: '',
    //             isNested: false,
    //             isContainerDimension: true,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Length', value: 'length', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Height', value: 'height', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Width', value: 'width', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Type', value: 'type', defaultValue: 'NA' }
    //             ]
    //         },
    //         {
    //             title: "Cargo Description",
    //             titleKey: '',
    //             isNested: true,
    //             nestedKey: "cargo_description_tables",
    //             nestedNumber: 'desc_seq_number',
    //             childData: [
    //                 { label: 'Piece Count', value: 'piece_count', defaultValue: 'NA', dynamicUnit: true, unitField: 'manifest_unit',},
    //                 { label: 'Description', value: 'cargo_description', defaultValue: 'NA', isReadMore: true, readMoreLength: 65,},
    //                 // { label: '', value: 'table', isTable: true, tableHeaderKey: ['HS Code', 'Value (USD)', 'Weight (kg)'], tableContentKey:['hscode', 'value', 'weight'] }
    //             ]
    //         },
    //         {
    //             title: "HAZMAT Sequence",
    //             titleKey: 'hazmat_sequence_number',
    //             isNested: true,
    //             nestedKey: "hazmat_sequence_tables",
    //             nestedNumber: 'hazmat_sequence_number',
    //             childData: [
    //                 { label: 'Sequence Number', value: 'hazmat_sequence_number', defaultValue: 'NA' },
    //                 { label: 'Code', value: 'hazmat_code', defaultValue: 'NA' },
    //                 { label: 'Class', value: 'hazmat_class', defaultValue: 'NA' },
    //                 { label: 'Code Qualifier', value: 'hazmat_code_qualifier', defaultValue: 'NA' },
    //                 { label: 'Contact', value: 'hazmat_contact', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp.', value: 'hazmat_flash_point_temperature', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Negative Ind', value: 'hazmat_flash_point_temperature_negative_ind', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Unit', value: 'hazmat_flash_point_temperature_unit', defaultValue: 'NA' },
    //                 { label: 'Description', value: 'hazmat_description', defaultValue: 'NA' },
    //                 { label: 'Classification', value: 'hazmat_classification', defaultValue: 'NA' },
    //             ]
    //         },
    //     ]
    // },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_origin_english",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export -> Country of Import)",
    derived_consignee_master_name: "Unique Importers",
    // derived_shipper_master_name:"Unique Exporters",
    derived_country_of_origin_english: "Countries of Origin",
    derived_country_of_export_english: "Countries of Export",
    derived_mode_of_transport_english: "Mode of Transportation",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const ArgentinaImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default ArgentinaImportSearch;
